"use client";

import React from "react";
import { BriefcaseBusiness, CalendarClock, MapPin, UsersRound } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const details = [{
  title: "Primary Location",
  description: "RiverBend’s office is located at 1186 Roland St., Thunder Bay, Ontario. Some opportunities may involve client-community work or flexible arrangements depending on the role.",
  icon: MapPin
}, {
  title: "Opportunity Type",
  description: "General expression of interest for future RiverBend roles and possible client-related opportunities.",
  icon: BriefcaseBusiness
}, {
  title: "Application Status",
  description: "Open on an ongoing basis. We review expressions of interest as RiverBend and client needs arise.",
  icon: CalendarClock
}, {
  title: "Areas of Interest",
  description: "Accounting, bookkeeping, program management, project management, consulting, year-end support, Microsoft 365 systems, and economic development support.",
  icon: UsersRound
}];
export default function ValuesPillars() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257904" id="quick-job-details" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-12 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-secondary font-default font-bold tracking-wider uppercase text-sm mb-4">
            Position Overview
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary-500 mb-6">
            Quick Job Details
          </h2>

          <p className="text-lg text-muted-foreground font-default leading-relaxed">
            This expression of interest is for people who want to contribute to
            meaningful work with RiverBend, our clients, or future opportunities
            connected to First Nation communities, Northern organizations, and
            economic development work.
          </p>
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 transition-all duration-1000 ease-out delay-200 ${areCardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {details.map((item, i) => {
          const Icon = item.icon;
          return <Card key={item.title} data-index={i} className="h-full bg-card border border-border shadow-sm rounded-lg">
                <CardContent className="p-7 md:p-8">
                  <div className="size-12 rounded-md bg-secondary/10 flex items-center justify-center mb-5">
                    <Icon className="size-6 text-secondary" />
                  </div>

                  <h3 className="text-xl font-default font-bold text-primary-500 mb-3">
                    {item.title}
                  </h3>

                  <p className="text-muted-foreground font-default leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}